<template>
  <!-- 学习视频页面 -->
  <section class="container">
    <div class="wrapper courseM">
      <div class="head">
        <p class="title">{{ courseinfo.title }}</p>
        <div class="courseinfo">
          <p class="lecturer">讲师介绍:{{ courseinfo.lecturerName }}</p>
          <Button class="info-btn" type="primary" @click="showdrawer" data-id="0">课程介绍</Button>
          <Button class="info-btn" type="primary" @click="showdrawer" data-id="1">讲师介绍</Button>
          <!-- <Button class="info-btn" type="primary" @click="showdrawer" data-id="2">课程讲义</Button> -->
        </div>
      </div>
      <div class="flex-row inner-wrapper">
      <div class="col-70">
        <div class="video-container" @contextmenu.prevent>
          <video-player class="video-player vjs-custom-skin" id="video" ref="videoPlayer" :playsinline="true"
            :options="playerOptions" @play="onPlayerPlay($event)" @pause="onPlayerPause($event)"
            @ended="onPlayerEnded($event)" @canplay="onPlayerCanplay($event)" @timeupdate="onPlayerTimeupdate($event)"
            @statechanged="playerStateChanged($event)"></video-player>
          <canvas ref="watermarkCanvas" class="watermark"></canvas>
        </div>
      </div>
        <div class="col-30 relative">
          <div class="cover text-left">
            <img :src="courseinfo.cover" alt />
          </div>
          <!-- <div class="commentM">
            <div class="title2 text-left">评论</div>
            <div class="com-wrapper">
              <div class="flex-row comment" v-for="(comment, index) in commentList" :key="index">
                <div class="col-15 text-left">
                  <img
                    v-if="comment.headImg != '' || comment.headImg != null"
                    class="headImg"
                    :src="comment.headImg"
                    alt
                  />
                  <img v-else class="headImg" src="../assets/head.png" alt />
                </div>
                <div class="col-80">
                  <div class="name text-left">{{comment.realName}}</div>
                  <div class="comment-body text-left">{{comment.content}}</div>
                  <div class="date flex-row">
                    <div class="col-50 text-left">{{comment.createTime}}</div>
                    <div class="col-50 text-right">
                      <span
                        class="pointer"
                        v-if="comment.commentId != parentId "
                        @click="replyClick"
                        :data-name="comment.realName"
                        :data-id="comment.commentId"
                      >回复</span>
                      <span class="pointer color-yellow" v-else @click="emptyinput">取消回复</span>
                    </div>
                  </div>
                  <div class="inside-comment relative" v-if="comment.subCommentList.length != 0">
                    <div class="triangle_border_up">
                      <span></span>
                    </div>
                    <div
                      class="inside text-left"
                      v-for="(subcomment, index2) in comment.subCommentList"
                      :key="index2"
                    >{{subcomment.realName}}：{{subcomment.content}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>-->
          <!-- <div class="inputM">
            <Input
              v-model="comment"
              search
              enter-button="发送"
              @on-search="addComment"
              :placeholder="parentId ? '回复' + parent : '请输入您的评论'"
            />
          </div>-->
        </div>
      </div>
      <div style="color: red;margin-top:20px;text-align: left;">*建议退出页面前将视频暂停，否则可能会造成视频未成功记录进度的情况！</div>
      <Button class="course-btn" type="primary" @click="gotolearn" data-id>返回学习页面</Button>
    </div>
    <Footer></Footer>
    <Drawer :title="drawerName" v-model="drawer" width="400px">
      <div class="courseintro" v-show="drawertype == 0">
        <p>课程介绍 : {{ courseinfo.title }}</p>
        <p>课程时间 : {{ courseinfo.period }}节</p>
        <p>授课对象 : {{ courseinfo.courseObject }}</p>
        <p class="preline">
          课程内容 :
          {{ courseinfo.summary }}
        </p>
      </div>
      <div class="lecturerintro" v-show="drawertype == 1">
        <img v-if="courseinfo.lecturerPicture != null" :src="courseinfo.lecturerPicture" alt />
        <img v-else src="../assets/head.png" alt />
        <p>讲师名称 : {{ courseinfo.lecturerName }}</p>
        <p class="preline">{{ courseinfo.lecturerIntro }}</p>
      </div>
      <!-- <div class="courseintro" v-show="drawertype == 2">
        <p class="preline">
          课程讲义 :
          {{ courseinfo.courseHandouts }}
        </p>
      </div> -->
    </Drawer>
    <Modal v-model="modal" @on-ok="ok" :scrollable="modelScrollable">
      <h2 style="padding: 25px 0 15px;" class="text-center">是否继续上次播放</h2>
    </Modal>
    <Modal v-model="continueModel" @on-ok="continuePlay" :scrollable="modelScrollable" :transfer="continueModel">
      <h2 style="padding: 25px 0 15px;" class="text-center">是否继续学习</h2>
    </Modal>
  </section>
</template>

<script>
import Footer from "./components/Footer";
import { videoPlayer } from "vue-video-player";
import { MessageBox } from "element-ui";
export default {
  name: "Course",
  data() {
    return {
      modal: false,
      continueModel: false, //继续学习的model
      continuetime: 0, //继续学习的时间
      setIntervalModel: {}, //计算继续学习的定时器
      modelScrollable: false,
      drawer: false, //抽屉层
      drawerName: "",
      drawertype: 1,
      courseinfo: {
        //课程信息
        contentId: "", //课程内容ID
        cover: "",
        title: "", //课程名称
        videoUrl: "", //视频地址
        videoTime: "", //视频时间
        videoDuration: "", //视频时长/秒
        currentTime: "", //当前播放位置
        progress: "", //学习进度/%
        period: "", //课时
        courseObject: "", //授课对象
        courseContent: "", //课程内容
        lecturerName: "", //讲师
        lecturerIntro: "", //讲师介绍
        lecturerPicture: "", //讲师图片
        courseHandouts: "", //课程讲义
        summary: "", // 后台小课结的课程摘要字段
      },
      playerOptions: {}, //setVideoOption 修改视频配置参数
      last: 0, //课程记录最后的播放位置
      commentList: [], //评论列表
      comment: "", //评论的内容
      parentId: "", //父级评论id
      parent: "", //父级评论
      status: 0, //视频播放状态  0是暂停 1是播放
      type: 0,
    };
  },
  beforeRouteLeave(to, from, next) {
    this.setCouserSchedule();
    const answer = window.confirm("当前正在学习中，是否要退出？");
    if (answer) {
      next();
    } else {
      next(false);
    }
  },
  beforeDestory() {
    this.setCouserSchedule();
  },
  mounted() {
    var that = this;
    that.onload();
    that.getComment();
    that.type = that.$route.query.type;
    window.addEventListener("beforeunload", e => this.browerStatus());
    //  判断网页是否失去焦点
    window.onblur = function (e) {
      var path = that.$route.path;
      if (path.indexOf("Course") === 1) {
        that.player.pause();
      }
    };
    //判断网页是否激活状态 --没有判断是否失去焦点
    var hiddenProperty =
      "hidden" in document
        ? "hidden"
        : "webkitHidden" in document
          ? "webkitHidden"
          : "mozHidden" in document
            ? "mozHidden"
            : null;
    var visibilityChangeEvent = hiddenProperty.replace(
      /hidden/i,
      "visibilitychange"
    );
    var onVisibilityChange = function () {
      if (!document[hiddenProperty]) {
        // console.log('页面非激活');
      } else {
        // console.log('页面激活')
      }
    };
    document.addEventListener(visibilityChangeEvent, onVisibilityChange);

    // 全屏/窗口变化时重绘水印
    function onFullscreenChange() {
      setTimeout(function () { that.drawWatermark(); }, 100);
    }
    document.addEventListener('fullscreenchange', onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', onFullscreenChange);
    window.addEventListener('resize', onFullscreenChange);


    window.onbeforeunload = function (e) {
      e = e || window.event;
      that.setCouserSchedule();
      // console.log(that.status);
      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        e.returnValue = "当前正在学习中，是否要退出？";
        that.setCouserSchedule();
        that.status = 0;
        var time = parseInt(that.last);
        var token = that.$cookie.get("xjaf-token");
        var modelData = {
          currentTime: time,
          contentId: that.courseinfo.contentId
        };
        that.setCouserSchedule();
        // $.ajax({
        //   url: that.webhost + "course/record/progress",
        //   method: "POST",
        //   async: false,
        //   dataType: "json",
        //   data: {
        //     "currentTime": time,
        //     "contentId": that.courseinfo.contentId
        //   },
        //   headers:{
        //     Token: token
        //   },
        // }).then(({ data }) => {
        //   if (data && data.code === 0) {
        //     that.currentTime = time;
        //   } else {
        //     that.$Message.error(data.msg);
        //   }
        // });
      }
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      return "当前正在学习中，是否要退出？";
    };
  },
  watch: {
    status: function (newQuestion, oldQuestion) {
      var that = this;
      if (newQuestion == 1) {
        that.setIntervalModel = setInterval(function () {
          that.continuetime += 1;
        }, 1000);
      } else {
        that.continuetime = 0;
        window.clearInterval(that.setIntervalModel);
      }
    },
    continuetime: function (newQuestion, oldQuestion) {
      var that = this;
      if (newQuestion == 600) {
        that.player.pause();
        // that.continueModel = true;
        alert("你当前已经学习了10分钟，是否继续学习");
      }
    }
  },
  components: {
    videoPlayer,
    Footer
  },
  methods: {
    browerStatus() {
      this.setCouserSchedule();
    },
    onload() {
      //初始化
      var that = this;
      var token = that.$cookie.get("xjaf-token");
      var username = that.$cookie.get("xjaf-user");
      if (token != null && username != null) {
        this.checkToken();
        this.httpcourse();
      } else {
        this.$store.commit("login");
      }
    },
    checkToken() {
      var that = this;
      var token = that.$cookie.get("xjaf-token");
      this.$http({
        url: that.webhost + "checkToken", //接受手机的接口
        method: "POST",
        data: token
      }).then(({ data }) => {
        // console.log(data, data.code);
        if (data.code === 0) {
        } else if (data.code === 1) {
          //清除cookies 重新登录
          this.$cookie.delete("xjaf-user");
          this.$cookie.delete("xjaf-token");
          MessageBox.alert(
            "系统检测到您已在其他地方登录，若要继续使用请重新登录！"
          ).then(action => {
            that.$router.go(0);
          });
        }
      });
    },
    httpcourse() {
      //加载页面初始化
      var that = this;
      console.log(this.$store.state.subjectCode, 66778);

      var contentId = that.$route.params.contentId;
      this.$http({
        url: that.webhost + "course/courseContentWeb/" + contentId,
        method: "GET"
      })      .then(({ data }) => {
        if (data && data.code === 0) {
          that.courseinfo = data.data;
          that.playerOptions = that.setVideoOption(data.data.videoUrl);
          that.$nextTick(function () { that.drawWatermark(); });
          if (this.courseinfo.currentTime > 5) {
            this.modal = true;
          }
        } else {
          that.$Message.error(data.msg);
        }
      });
    },
    showdrawer(e) {
      //展示抽屉层
      var that = this;
      that.drawertype = e.currentTarget.dataset.id;
      switch (that.drawertype) {
        case 0:
          that.drawerName = "课程介绍";
          break;
        case 1:
          that.drawerName = "讲师介绍";
          break;
        // case 2:
        //   that.drawerName = "课程讲义";
        //   break;
      }
      that.drawer = true;
    },
    setVideoOption(videoUrl) {
      //视频参数配置
      return {
        // playbackRates: [0.75, 1.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            // src:'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm'
            src: videoUrl //你的视频地址（必填）
          }
        ],
        poster: "poster.jpg", //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          // timeDivider: true,
          // durationDisplay: true,
          // remainingTimeDisplay: false,
          // fullscreenToggle: true  //全屏按钮,
          // progressControl: true,
        }
        // controlBar: false
      };
    },
    ok() {
      //继续上次播放记录
      this.last = this.courseinfo.currentTime;
      this.player.currentTime(this.courseinfo.currentTime);
      this.player.play();
    },
    continuePlay() {
      //继续播放
      this.player.play();
    },

    onPlayerPlay(player) {
      //监听点击播放
      this.status = 1;
      // console.log(this.status)
    },
    onPlayerPause(player) {
      //监听暂停事件
      this.setCouserSchedule();
      // var a = "12441";
      // var modal = player.createModal(a);
      // modal.on('modalclose', function() {
      //   player.play();
      // });
    },
    onPlayerTimeupdate(player) {
      // //监听进度条--禁止快进
      var current = player.currentTime();
      if (current - this.last > 1) {
        player.currentTime(this.last);
      } else {
        this.last = current;
      }
    },
    onPlayerEnded(player) {
      //视频播放完成
      this.setCouserSchedule();
    },
    onPlayerCanplay(player) {
      var that = this;
      // 将 Canvas 放入 video-js 播放器内部（全屏时跟随）
      var canvas = this.$refs.watermarkCanvas;
      var el = player.el();
      if (canvas && el && canvas.parentElement !== el) {
        el.style.position = 'relative';
        el.insertBefore(canvas, el.firstChild);
      }
      // 监听 video-js 全屏变化
      player.on('fullscreenchange', function () {
        setTimeout(function () { that.drawWatermark(); }, 200);
      });
      this.drawWatermark();
    },
    drawWatermark() {
      var s = this.$route.query.subjectCode;
      var code = s ? Number(s) : this.$store.state.subjectCode;

      let logoPath = null;
      if ([1, 2].includes(code)) logoPath = require('../assets/logo_2.png');
      else if (code === 3) logoPath = require('../assets/logo_3.png');
      else if ([5, 6, 7].includes(code)) logoPath = require('../assets/logo_1.png');

      const canvas = this.$refs.watermarkCanvas;
      if (!canvas || !logoPath) return;

      // Canvas 已在 player 内部，用 absolute 填满父容器
      canvas.style.cssText =
        'position:absolute;top:0;left:0;width:100%;height:100%;display:block;' +
        'pointer-events:none;z-index:10;';

      var container = canvas.parentElement;
      var w = container.offsetWidth;
      var h = container.offsetHeight;
      if (w === 0 || h === 0) { w = 840; h = 472.5; }

      var dpr = window.devicePixelRatio || 1;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      var ctx = canvas.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      var img = new Image();
      img.onload = function () {
        ctx.clearRect(0, 0, w, h);
        ctx.globalAlpha = 0.2;

        // 旋转画布，实现倾斜水印
        var angle = -Math.PI / 6; // -30度
        var diagonal = Math.sqrt(w * w + h * h);
        ctx.save();
        ctx.translate(w / 2, h / 2);
        ctx.rotate(angle);

        var stepX = 160, stepY = 140, logoW = 120;
        var logoH = (img.height / img.width) * logoW;
        for (var y = -diagonal; y < diagonal; y += stepY) {
          for (var x = -diagonal; x < diagonal; x += stepX) {
            ctx.drawImage(img, x, y, logoW, logoH);
          }
        }
        ctx.restore();
        ctx.globalAlpha = 1;
      };
      img.onerror = function () {};
      img.src = logoPath;
    },
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
    setCouserSchedule() {
      // 记录课程播放进度
      var that = this;
      that.status = 0;
      var time = parseInt(that.last);
      var modelData = {
        currentTime: time,
        contentId: that.courseinfo.contentId
      };
      this.$http({
        url: that.webhost + "course/record/progress",
        method: "POST",
        data: modelData
      }).then(({ data }) => {
        if (data && data.code === 0) {
          that.currentTime = time;
        } else {
          that.$Message.error(data.msg);
        }
      });
    },
    gotolearn() {
      this.setCouserSchedule();
      console.log("type为" + this.type);
      if (this.type == 1) {
        this.$router.push("/Elective");
      } else if (this.$route.query.from === 'IndustryTraining') {
        this.$router.push(`/IndustryTraining?subjectCode=${this.$route.query.subjectCode}&showList=true`);
      } else {
        // this.$router.push("/Learn");
        this.$router.go(-1);
      }
    },
    emptyinput() {
      // 评论本课程
      var that = this;
      that.parentId = "";
      that.parent = "";
      $(".inputM input").focus();
    },
    replyClick(e) {
      //回复别人的评论
      var id = +e.currentTarget.dataset.id;
      var name = e.currentTarget.dataset.name;
      this.parentId = id;
      this.parent = name;
      $(".inputM input").focus();
    },
    getComment() {
      //获取评论接口
      var that = this;
      var modelData = {
        contentId: that.$route.params.contentId,
        page: 1,
        size: 50
      };
      this.$http({
        url: that.webhost + "course/comment/list",
        method: "POST",
        data: modelData
      }).then(({ data }) => {
        if (data && data.code === 0) {
          that.commentList = data.data.list;
        } else {
          that.$Message.error(data.msg);
        }
      });
    },
    addComment() {
      //评论接口
      var that = this;
      if (!that.comment) {
        that.$Message.error("评论内容不能为空！");
        return false;
      }
      var modelData = {
        content: that.comment,
        contentId: that.courseinfo.contentId,
        parentId: that.parentId
      };
      this.$http({
        url: that.webhost + "course/comment/create",
        method: "POST",
        data: modelData
      }).then(({ data }) => {
        that.comment = "";
        that.parentId = "";
        that.parent = "";
        if (data && data.code === 0) {
          that.$Message.success("评论成功！");
          that.commentList = [];
          that.getComment();
        } else {
          that.$Message.error(data.msg);
        }
      });
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  beforeRouteLeave(to, from, next) {
    //监听离开页面时候记录课程播放记录
    var that = this;
    if (that.status == 1) {
      var time = parseInt(that.last);
      var modelData = {
        currentTime: time,
        contentId: that.courseinfo.contentId
      };
      this.$http({
        url: that.webhost + "course/record/progress",
        method: "POST",
        data: modelData
      }).then(({ data }) => {
        if (data && data.code === 0) {
          next();
        } else {
          that.$toast.error(data.msg);
        }
      });
    } else {
      next();
    }
  }
};
</script>

<style scoped>
.wrapper {
  width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  margin-bottom: 90px;
  font-family: "PingFang SC";
}

.head {
  overflow: hidden;
  font-size: 25px;
  line-height: 70px;
  color: #000;
  border-bottom: solid 2px #ccc;
}

.head .title {
  text-align: left;
  float: left;
}

.head .courseinfo {
  float: right;
  overflow: hidden;
}

.head .courseinfo .lecturer {
  float: left;
  margin-right: 20px;
  font-size: 20px;
}

.head .courseinfo .info-btn {
  float: left;
  margin-top: 20px;
  margin-left: 20px;
}

.video-player {
  width: 840px;
  height: 472.5px;
}

.video-container {
  position: relative;
  width: 840px;
  height: 472.5px;
  overflow: hidden;
}

.inner-wrapper {
  margin-top: 20px;
  height: 472px;
}

.inner-wrapper .col-30 {
  padding: 0 0 10px 10px;
}

.cover img {
  width: 340px;
  height: 185px;
}

.commentM {
  height: 282px;
  overflow-y: auto;
}

.title2 {
  color: #333;
  font-size: 21px;
  font-weight: bold;
  overflow: hidden;
}

.title2 .head-left {
  float: left;
}

.title2 .head-right {
  float: right;
  font-size: 16px;
  cursor: pointer;
  margin-right: 10px;
  line-height: 31px;
}

.inputM {
  width: 100%;
  position: absolute;
  bottom: 0;
}

.headImg {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

.com-wrapper {
  height: 251px;
  overflow-y: auto;
  padding-bottom: 35px;
}

.comment {
  padding: 5px 0;
}

.comment .name {
  font-size: 16px;
}

.comment .comment-body {
  font-size: 13px;
  padding: 5px 0;
  color: #666;
}

.date {
  font-size: 12px;
  color: #666;
}

.inside-comment {
  margin-top: 10px;
  background-color: #f1f1f1;
  padding: 5px 15px;
  border-radius: 5px;
}

.inside-comment .inside {
  padding: 2px 0;
}

/*向上*/
.triangle_border_up {
  width: 0;
  height: 0;
  border-width: 0 5px 5px;
  border-style: solid;
  border-color: transparent transparent #f1f1f1;
  position: absolute;
  top: -5px;
  left: 15px;
}

.courseintro {
  font-size: 18px;
  line-height: 25px;
  text-align: left;
  color: #000;
}

.lecturerintro {
  font-size: 18px;
  line-height: 25px;
  text-align: left;
  color: #000;
}

.lecturerintro img {
  display: block;
  margin: 20px auto;
  width: 150px;
}

.preline {
  white-space: pre-line;
}

.color-yellow {
  color: #bc8c3e;
}

.course-btn {
  width: 200px;
  font-size: 15px;
  height: 40px;
  margin: auto;
  margin-top: 50px;
}
</style>

<style>
.courseM button {
  outline: none;
  /*background-color: #23b8ff;*/
}
</style>



// WEBPACK FOOTER //
// src/views/Course.vue